<template>
    <svg role="presentation" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:xlink:href="spriteHref"></use></svg>
</template>

<script>
export default {
    name: 'Sprite',
    props: ['spriteId'],
    computed: {
        spriteHref() {
            return `/images/sprites.svg#${this.spriteId}`
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/js/components/_Sprite.vue